import "./TextInputDebounced.css";

import { useCallback, useEffect, useMemo, useState } from "react";
import { useDebounce } from "../../../hooks/useDebounce";
import { CssClassNameBuilder } from "../../../utils/CssClassNameBuilder1";
import { IconButton } from "../../buttons/IconButton";

interface ITextInputDebouncedProps {
  value?: string;
  className?: string;
  placeholder? :string;
  type?: 'email'
  | 'number'
  | 'password'
  | 'text';
  onChange?: (value: string) => void;
  icon? : React.ReactNode;
}

export function TextInputDebounced(props: ITextInputDebouncedProps) {
  const [inputValue, setInputValue] = useState(props.value || "");
  const debouncedValue = useDebounce(inputValue, 500);

  useEffect(() => {
    const prevValue = props.value || "";
    const isDebouncedEmpty = debouncedValue === "";
    const isPreviousValueNotEmpty = prevValue !== "";

    if (
      (debouncedValue !== prevValue) ||
      (isDebouncedEmpty && isPreviousValueNotEmpty)
    ) {
      props.onChange && props.onChange(debouncedValue);
    }
  }, [debouncedValue]);

  useEffect(() => {
    setInputValue(props.value || "");
  }, [props.value]);

  const handleChange = useCallback((ev: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(ev.target.value);
  }, []);

  const handleClear = useCallback(() => {
    props.onChange && props.onChange("");
  }, []);

  const textInputCss = useMemo(() => {
    return CssClassNameBuilder.new()
      .add("text-input")
      .addConditional(props.className, props.className)
      .addConditional(props.icon, "has-icon")
      .build();
  }, [props.className, props.icon]);

  return (
    <div className={textInputCss}>
      <input
        className="native-input"
        placeholder={props.placeholder}
        type={props.type}
        value={inputValue}
        onChange={handleChange}
      />
      {props.icon && inputValue.length ? <IconButton icon={props.icon} onClick={handleClear} /> : null}
    </div>
  );
}
